<template>
    <section class="charts">
        <!-- {{ cSeriesPrincipal }}
        {{ cSeriesSecondary }}
        {{ drilldownOptions }}
        <button class="btn btn-default" @click="update">Actualizar</button> -->
        <vue-highcharts :highcharts="Highcharts" :options="drilldownOptions" ref="drilldownChart"></vue-highcharts>
    </section>
</template>
<script>
import VueHighcharts from "vue2-highcharts";
import Drilldown from "highcharts/modules/drilldown.js";
import Exporting from "highcharts/modules/exporting";
// import * as data from "../assets/data.js";
import Highcharts from "highcharts";

Exporting(Highcharts);
Drilldown(Highcharts);
Highcharts.setOptions({
  lang: {
    drillUpText: "Atras"
  }
});

const data={
    };

export default {
  name:'bar-chart',
  props:{
        title:{
            type:String,
            default:'Titulo Gráfico'
        },
        subtitle:{
            type:String,
            default:'Subtitulo Grafico'
        },
        xAxisTitle:{
            type:String,
            default:'Valores Horizontales'
        },
        yAxisTitle:{
            type:String,
            default:'Valores Laterales'
        },
        seriesPrincipal:{
            type:Array,
            default:function(){
                    return [{name: "Datos", y: 0, drilldown: "id_submenu"}];
                }
        },
        seriesSecondary:{
            type:Array,
            default:function(){
                return [
                        {
                            id: "id_submenu",
                            data: [{name:"Cats", y:1}, {name:"Dogs", y:2}]
                        }
                    ]
            }
        }     
  },
  components: {
    VueHighcharts
  },
  data() {
    return {
      Highcharts: Highcharts,
      drilldownOptions: {
        chart: {
            type: "column"
        },
        title: {
            text: this.title
        },
        subtitle:{
            text: this.subtitle
        },
        xAxis: {
            title:{
                text:this.xAxisTitle
            },
            type: "category"
        },
        yAxis: {
            title: {
              text: this.yAxisTitle
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 1,
                dataLabels: {
                    enabled: true
                }
            }
        },
        series: [
        {
            name: "Operaciones",
            colorByPoint: true,
            data: this.seriesPrincipal
        }
        ],
        drilldown: {
            series: this.seriesSecondary
        }
    }
    }
  },
  methods:{
      update(){
        let drill= this.$refs.drilldownChart;
        // console.log(this.$refs);
        console.log(drill);
        // this.$refs.drilldownChart.removeSeries();
        // console.log('removiendo la series')
        // drill.initHigcharts();
        // this.$refs.drilldownChart.options.series[0].data=this.cSeriesPrincipal;
        // this.$refs.drilldownChart.getChart();
        // this.$refs.drilldownChart.initHigcharts();
        // this.seriesPrincipalNew=this.seriesPrincipal;
        // this.seriesSecondaryNew=this.seriesSecondary;
        // drill.delegateMethod("showLoading", "Loading...");
          console.log('actualizando el grafico')
        //   drilldownChart.getChart();
      },
      load(){
          
      }
  },
  computed:{
      cSeriesPrincipal(){
        //   this.update();
          return this.seriesPrincipal;
      },
      cSeriesSecondary(){
          return this.seriesSecondary;
      }
  },
  watch:{
      drilldownOptions(){
        //   this.update();
          return this.drilldownOptions;
      }
  }
};
</script>
<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/charts/BarChart.vue